import { BoxExplorer } from "react-box-explorer";
import "react-box-explorer/style.css";

import useBoxBaseUrls from "@shared/hooks/useBoxBaseUrls";
import Tabs, { TAB_VARIANTS } from "@shared/ui/Tabs";
import React from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

import ContentLoading from "@shared/ui/ContentLoading";
import {
  DeleteTrashImage,
  NotFoundComponent,
} from "@shared/ui/NotFoundComponent";

/** Mirrors oem's DOCUMENTS_TABS; the values are part of the Box folder contract. */
const DOCUMENTS_TABS = { EXTERNAL: "external", INTERNAL: "internal" };

const PartDocuments = ({
  userFolderToken,
  part,
  allowModification = true,
  isSharedAssetsPage = false,
}) => {
  const { boxBaseUrls } = useBoxBaseUrls();

  const { messages } = useIntl();
  const location = useLocation();
  const isRequestPage = location.pathname.includes("app/asset-hub/requests");
  const [isExternalDocument, setIsExternalDocument] = React.useState(
    isSharedAssetsPage || isRequestPage,
  );

  const hasNoPartDocuments =
    !part?.documentFolders?.internalId && !part?.documentFolders?.externalId;

  const showDocumentsForPart =
    part?.documentFolders?.internalId && part?.documentFolders?.externalId;

  const isCreatingBoxFolderIds = () => {
    return (
      !part?.documentFolders?.internalId || !part?.documentFolders?.externalId
    );
  };

  const buildFoldersArray = (folderId) => {
    if (!folderId) return [];
    return [
      {
        folderId,
        token: userFolderToken,
        canUpload: allowModification,
        canCreateFolder: allowModification,
        canRename: allowModification,
        canDelete: allowModification,
        canPreview: true,
        canDownload: true,
      },
    ];
  };

  return (
    <>
      {isCreatingBoxFolderIds() ? (
        <ContentLoading />
      ) : (
        <>
          <div className="u-flex u-margin-b-3 template-doc__buttons">
            {!isSharedAssetsPage && !isRequestPage && (
              <Tabs
                variant={TAB_VARIANTS.SEGMENT}
                tabs={[
                  {
                    id: DOCUMENTS_TABS.INTERNAL,
                    label: messages?.inventory?.internalDocuments,
                    isActive: !isExternalDocument,
                  },
                  {
                    id: DOCUMENTS_TABS.EXTERNAL,
                    label: messages?.inventory?.externalDocuments,
                    isActive: isExternalDocument,
                  },
                ]}
                onTabChange={(tabId) => {
                  if (tabId === DOCUMENTS_TABS.EXTERNAL) {
                    setIsExternalDocument(true);
                  } else {
                    setIsExternalDocument(false);
                  }
                }}
              />
            )}
          </div>

          {showDocumentsForPart ? (
            <>
              {isExternalDocument ? (
                <BoxExplorer
                  {...boxBaseUrls}
                  key={part?.documentFolders?.externalId}
                  folders={buildFoldersArray(part?.documentFolders?.externalId)}
                  entityName={part?.name}
                  useBoxUploader
                />
              ) : (
                <BoxExplorer
                  {...boxBaseUrls}
                  key={part?.documentFolders?.internalId}
                  folders={buildFoldersArray(part?.documentFolders?.internalId)}
                  entityName={part?.name}
                  useBoxUploader
                />
              )}
            </>
          ) : null}

          {hasNoPartDocuments ? (
            <NotFoundComponent
              key="not-found-any-machine-doc"
              icon={<DeleteTrashImage />}
              title={
                messages?.tickets?.ticketDetails.ticketOverviewTab.noDocuments
              }
            />
          ) : null}
        </>
      )}
    </>
  );
};

export default PartDocuments;
